import { CoreFlowState } from 'core/core-flow-state';

/**
 * @module SalesFlow/evolved/view
 */

declare var $: JQueryStatic;

import Injector from 'core/injector';
import DeviceList from 'view/element/shared/device-list';
import AttributeRepo from 'model/repo/attribute-repo';
import DeviceTile from 'view-evolved/element/redplus/view-evolved--element-redplus--device-tile';
import DeviceOffer from 'view/view/shared/offer/device-offer';
import {ActiveFilterOptionsByGroup} from 'view/element/shared/filter/filters';
import { ViewEvolvedElementRedPlusInsuranceDetailOverlay } from './view-evolved--element-redplus--insurance-detail-overlay';

export class ViewEvolvedElementRedPlusDeviceList extends DeviceList {

    protected _tileHbs = 'redplus_device_tile';

    protected _attributeRepo: AttributeRepo;

    protected _deviceTile: DeviceTile[];

    private _insuranceDetailOverlay: ViewEvolvedElementRedPlusInsuranceDetailOverlay;

    protected _focusAtomicDeviceId: number;

    constructor (injector: Injector, attributeRepo: AttributeRepo, focusAtomicDeviceId: number) {
        super(injector);

        this._attributeRepo = attributeRepo;
        this._focusAtomicDeviceId = focusAtomicDeviceId;
        this._insuranceDetailOverlay = new ViewEvolvedElementRedPlusInsuranceDetailOverlay(this._injector);

    }

    public events (): void {

        this._element.on('click', '.redplus-device-accordion-toggle', (evt) => {
            setTimeout(() => {
                this._slider.updateHeight();
            }, 800);
        });

        this._insuranceDetailOverlay.bind();

        // @TODO deviceTiles are only a workaround

        this._deviceTile = this._viewOffers.map((deviceOffer: DeviceOffer): DeviceTile => {

            return new DeviceTile(
                this.getElement().find('.device-module-tile[data-device-id="' + deviceOffer.atomicDevice.device.id + '"]'),
                deviceOffer,
                this.getInjector()
            );

        });

        this.getElement().on('click', '.device-module-tile .selectionRadio', (evt) => {

            const deviceTile = evt.currentTarget.parentElement.parentElement;
            const atomicDeviceId = parseInt(deviceTile.dataset.atomicDeviceId, 10);

            if (atomicDeviceId === this._selectedAtomicDeviceId) {
                this._selectedAtomicDeviceId = undefined;
                this._coreFlowState.setAtomicDeviceId(undefined);
                this._coreFlowState.unlockDevice();
            } else {
                this._selectedAtomicDeviceId = atomicDeviceId;
                this._coreFlowState.setAtomicDeviceId(atomicDeviceId);
                this._coreFlowState.lockDevice();
            }

        });

        this.getElement().on('click', '.device-module-tile .selectionCheck', (evt) => {
            const deviceTile = evt.currentTarget.parentElement.parentElement;
            const deviceId = parseInt(deviceTile.dataset.atomicDeviceId, 10);

            if (deviceId === this._selectedAtomicDeviceId) {
                this._selectedAtomicDeviceId = undefined;
                this._coreFlowState.setAtomicDeviceId(undefined);
                this._coreFlowState.unlockDevice();
            } else {
                this._selectedAtomicDeviceId = deviceId;
                this._coreFlowState.setAtomicDeviceId(deviceId);
                this._coreFlowState.lockDevice();
            }
        });

        this.getInjector().getEvent().listen('atomicDeviceId@changed', (eventObject: JQueryEventObject, data: any) => {

            const atomicDeviceId = data.atomicDeviceId;

            this.getElement().find('.device-module-tile.selected').removeClass('selected');

            if (undefined === atomicDeviceId) {
                return;
            }

            this.getElement().find('.device-module-tile[data-atomic-device-id="' + atomicDeviceId + '"]').addClass('selected');

            this._slider.showSelectedElement();

        });

        this.getInjector().getEvent().listen('atomicDeviceId@changedByInsurance', (eventObject: JQueryEventObject, data: any) => {

            const atomicDeviceId = data.atomicDeviceId;

            this.getElement().find('.device-module-tile.selected').removeClass('selected');

            if (undefined === atomicDeviceId) {
                return;
            }

            this.getElement().find('.device-module-tile[data-atomic-device-id="' + atomicDeviceId + '"]').addClass('selected');

        });

        this.getInjector().getEvent().listen('filters@changed', (eventObject: JQueryEventObject, activeFilterOptionsByGroup: ActiveFilterOptionsByGroup) => {

            this.filterList(activeFilterOptionsByGroup);

        });

    }

    public update (devices: DeviceOffer[]): void {

        for (const device of devices) {

            for (const tile of this._deviceTile) {

                if (device.atomicDeviceId === tile.getDeviceOffer().atomicDeviceId) {

                    tile.setDeviceOffer(device);

                }

            }

        }

        super.update(devices);

    }

    public render (devices: DeviceOffer[]): string {
        super.render(devices);

        const customer = this.getInjector().getFlow().customer;
        if (customer.isSimOnlyVvlAllowed) {
            this.getElement().find('.selectionRadio').replaceWith(this.getInjector().getTemplates().render('selection-check', '', 'partials'));
        }

        return '';
    }

    private bindSlider (): void {

        let focusAtomicDeviceId: number;

        if (undefined !== this.getInjector().getFlow().getAtomicDeviceId()) {
            focusAtomicDeviceId = this.getInjector().getFlow().getAtomicDeviceId();
        }
        else if (undefined !== this._focusAtomicDeviceId) {
            focusAtomicDeviceId = this._focusAtomicDeviceId;
        }

        this._slider.bind(
            $('.device-module-tile[data-atomic-device-id="' + focusAtomicDeviceId + '"]')
        );

    }

    public bind (devices: DeviceOffer[]): void {

        super.bind(devices);

        this.bindSlider();
    }

}
